import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// 全局状态预留（与现行一致：当前无模块化 state，凭据走 cookie）
export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
